import React from 'react';
import PropTypes from 'prop-types';

import ItemFactBox from "./ItemFactBox";
import ItemImageBox from "./ItemImageBox";
import ItemCartBox from "./ItemCartBox";
import {getClassList} from "../../../Utility/siteConfig";
import {camelizeKeysDeep} from "../../../ReduxStore/Helpers/transformObject";
import CatchErrors from "../../../Utility/CatchErrors";

export default function StandardItemDisplay({className, product, ...props}) {

  // FIXME: 2025-04 not camelized until we get here.
  product = camelizeKeysDeep(product);

  className = getClassList({
    key: 'StandardItemDisplay',
    append: className,
    fallback: "grid lg:grid-cols-3 mb-4" // three equal columns
  });

  return <div className={className}>
    <CatchErrors><ItemImageBox product={product} {...props} /></CatchErrors>
    <CatchErrors><ItemFactBox product={product} {...props} /></CatchErrors>
    <CatchErrors><ItemCartBox product={product} {...props} /></CatchErrors>
  </div>;

}

StandardItemDisplay.propTypes = {
  product: PropTypes.object.isRequired,
  application: PropTypes.object, // optional, for universal
  dispatch: PropTypes.func.isRequired,
  cartItem: PropTypes.object
}
